module.exports = __webpack_public_path__ + "static/media/solutions-taxcaddy.62aba466.svg";